import type { MmkCategory } from "../../../types/mmk";
import { MMK_FILTER_CATEGORIES } from "../../../types/mmk";

export const CARD_CATEGORIES = MMK_FILTER_CATEGORIES.filter(
  (c): c is MmkCategory => c !== "All" && c !== "Personal",
);
